import axios from "axios";

const state = {
  stats: null,
  loading: false,
  error: null,
};

const mutations = {
  setStats(state, stats) {
    state.stats = stats;
  },
  setLoading(state, isLoading) {
    state.loading = isLoading;
  },
  setError(state, error) {
    state.error = error;
  },
};

const actions = {
  async fetchStats({ commit }, entrepriseId) {
    commit("setLoading", true);
    commit("setError", null);

    try {
      const response = await axios({
        url: `/entreprises/${entrepriseId}/stats`,
        method: "get",
        baseURL: process.env.VUE_APP_BACKEND_URL,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      commit("setStats", response.data);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Erreur lors du chargement des statistiques.";
      commit("setError", message);
      throw error;
    } finally {
      commit("setLoading", false);
    }
  },
};

const getters = {
  getStats: (state) => state.stats,
  isLoading: (state) => state.loading,
  getStatsError: (state) => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
